// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { EnrollableType } from 'util/siteManagementTypes';
import { InputTagField, InputTagFieldProps } from '../InputTagField';
import { useState } from 'react';
import { createAxios } from 'ts/createAxios';
import { handleError } from 'util/errorHandler';
import WarningModal from '../WarningModal';
import Portal from 'components/atoms/Portal';

type EnrollableTypeFieldProps = InputTagFieldProps & {
  type: 'recycle' | 'compressions';
  initialEnrollableTypes: EnrollableType[];
  siteId: string;
};

const EnrollableTypeField: React.FC<EnrollableTypeFieldProps> = ({
  type,
  onChangeData,
  initialEnrollableTypes,
  siteId,
  ...props
}) => {
  const [tmpChangedData, setTmpChangedData] = useState<string[]>();
  const [deletingItem, setDeletingItem] = useState<string>();

  const handleChangeData = (tagsValues: string[], deletingItem?: string) => {
    const deletingId =
      deletingItem != null
        ? initialEnrollableTypes.find((e) => e.name === deletingItem)?.id
        : undefined;

    if (deletingId == null) {
      onChangeData?.(tagsValues, deletingItem);
      setTmpChangedData(undefined);
      setDeletingItem(undefined);

      return;
    }

    createAxios()
      .post<{
        hasProcessingMaster: boolean;
      }>(`/sites/${type}/checking-material-type`, {
        materialTypeId: deletingId,
        siteId,
      })
      .then(({ data: { hasProcessingMaster } }) => {
        if (hasProcessingMaster) {
          setTmpChangedData(tagsValues);
          setDeletingItem(deletingItem);
        } else {
          onChangeData?.(tagsValues, deletingItem);
          setTmpChangedData(undefined);
          setDeletingItem(undefined);
        }
      })
      .catch(handleError);
  };

  return (
    <>
      <InputTagField {...props} onChangeData={handleChangeData} />

      {tmpChangedData != null && (
        <Portal>
          <WarningModal
            title="削除の確認"
            content={`${deletingItem}の投入重量がまだ残っています。\n本当に削除しますか？`}
            buttonConfirm="削除"
            onClose={() => {
              setTmpChangedData(undefined);
              setDeletingItem(undefined);
            }}
            onConfirm={() => {
              onChangeData?.(tmpChangedData);
              setTmpChangedData(undefined);
              setDeletingItem(undefined);
            }}
          />
        </Portal>
      )}
    </>
  );
};

export default EnrollableTypeField;
